import { AgentClient } from "@amazon-connect/contact";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/** AgentClient ships inside @amazon-connect/contact, not a separate agent package. */
export const agentModule: ClientModule = {
  id: "agent",
  label: "Agent",
  pkg: "@amazon-connect/contact",
  clientExport: "AgentClient",
  kind: "observable",
  create: (provider: AmazonConnectProvider) =>
    new AgentClient({ provider }) as unknown as Record<string, unknown>,
  events: [
    { name: "onStateChanged", off: "offStateChanged", deprecated: true },
    { name: "onAvailabilityStateChanged", off: "offAvailabilityStateChanged" },
    {
      name: "onNextAvailabilityStateChanged",
      off: "offNextAvailabilityStateChanged",
    },
    {
      name: "onEnabledChannelListChanged",
      off: "offEnabledChannelListChanged",
    },
    { name: "onRoutingProfileChanged", off: "offRoutingProfileChanged" },
    {
      name: "onNetworkConnectionStatusChanged",
      off: "offNetworkConnectionStatusChanged",
    },
  ],
  requests: [
    { name: "getARN", args: [] },
    { name: "getName", args: [] },
    { name: "getState", args: [], deprecated: true },
    { name: "getAvailabilityState", args: [] },
    { name: "getRoutingProfile", args: [] },
    { name: "getRoutingProfileQueues", args: [] },
    { name: "getDefaultOutboundQueue", args: [] },
    { name: "getChannelConcurrency", args: [] },
    { name: "getExtension", args: [] },
    { name: "getDialableCountries", args: [], deprecated: true },
    { name: "getNetworkConnectionStatus", args: [] },
    { name: "listAvailabilityStates", args: [] },
    // listQuickConnects(queueARNs, options?) — the plan had this as a zero-arg call.
    {
      name: "listQuickConnects",
      args: [
        { k: "queueARNs", type: "json", required: true },
        { k: "options", type: "json" },
      ],
    },
    { name: "listSecurityProfilePermissions", args: [] },
    // setAvailabilityState(agentStateARN: string) — a bare ARN string, not an object.
    {
      name: "setAvailabilityState",
      args: [{ k: "agentStateARN", type: "string", required: true }],
      mutating: true,
    },
    {
      name: "setAvailabilityStateByName",
      args: [{ k: "agentStateName", type: "string", required: true }],
      mutating: true,
    },
    { name: "setOffline", args: [], mutating: true },
  ],
};
